import React from 'react';
import { useGetIdentity, useGetList, usePermissions } from 'react-admin';
import { LinearProgress } from '@mui/material';
import { getUserPermissions } from '../model/cloud';

/**
 * Добавляет метод получения списка разрешений, изменяет logout
 * @param {object} authProvider - Auth provider, который надо расширить
 * @returns {object}
 */
export const authExtension = (authProvider) => {
	let identityStore = {};
	let permissionsStore = [];

	const getPermissions = () => {
		return authProvider.getIdentity()
			.then((identity) => {
				if (identityStore.id !== identity.id) {
					return getUserPermissions()
						.then((permissions) => {
							permissionsStore = [...permissions];
							identityStore = { ...identity };
							return permissions;
						});
				}
				return [...permissionsStore];
			})
			.catch(() => ([]));
	};

	return {
		...authProvider,
		getPermissions,
		logout: () => { identityStore = {}; permissionsStore = []; return authProvider.logout(); },
	};
};

export const hasRolePermissions = (permissions, role) => permissions && permissions.includes(role);
export const hasAnyRolesPermissions = (permissions, roles) => (
	permissions && (permissions.find((p) => roles.includes(p)) !== undefined)
);

export const hasMasterPermissions = (permissions) => permissions && permissions.includes('master');
export const withMasterPermissions = (permissions, param, defaultValue = null) => (
	hasMasterPermissions(permissions) ? param : defaultValue);

export const withAnyRolesPermissions = (permissions, roles, param, defaultValue = null) => (
	hasAnyRolesPermissions(permissions, roles) ? param : defaultValue);

export const WithMasterPermissions = (props) => {
	const { isLoading, permissions } = usePermissions();
	const { children, progressIndicator } = props;
	if (!hasMasterPermissions(permissions)) {
		return null;
	}
	if (isLoading) {
		return progressIndicator || <LinearProgress />;
	}
	return children || null;
};

export const WithAnyRolesPermissions = (props) => {
	const { isLoading, permissions } = usePermissions();
	const { children, progressIndicator, roles } = props;
	if (!hasAnyRolesPermissions(permissions, roles)) {
		return null;
	}
	if (isLoading) {
		return progressIndicator || <LinearProgress />;
	}
	return children || null;
};

export const usePermissionsExt = () => {
	const { isLoading: isPermissionsLoading, permissions } = usePermissions();
	const { isLoading: isIdentityLoading, identity: identityData } = useGetIdentity();
	const { isLoading: isBusinessAdminLoading, data: businessAdminData } = useGetList(
		'BusinessAdmin',
		{ filter: { parseUser: { id: identityData?.id } } },
	);
	const { isLoading: isTradeUnionLoading, data: tradeUnionData } = useGetList(
		'TradeUnionAdmin',
		{ filter: { parseUser: { id: identityData?.id } } },
	);
	return {
		isLoading: isPermissionsLoading
			|| isIdentityLoading || isBusinessAdminLoading || isTradeUnionLoading,
		permissions,
		master: permissions?.includes('master'),
		businessAdmin: permissions?.includes('businessAdmin'),
		businessAdminIds: businessAdminData?.map((i) => i.business?.id),
		tradeUnionAdmin: permissions?.includes('tradeUnionAdmin'),
		tradeUnionAdminIds: tradeUnionData?.map((t) => t.tradeUnion?.id),
	};
};
